import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { ModalDialogComponent } from "./components/modal-dialog/modal-dialog.component";
import { PaginationComponent } from "./form-controls/pagination/pagination.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { NotificationPaneComponent } from "./components/notification-pane/notification-pane.component";

@NgModule({
    imports: [
        HttpClientModule,
        CommonModule
    ],
    declarations: [
        ModalDialogComponent,
        PaginationComponent,
        SpinnerComponent,
        NotificationPaneComponent
    ],
    exports: [
        ReactiveFormsModule,
        CommonModule,
        ModalDialogComponent,
        PaginationComponent,
        SpinnerComponent,
        NotificationPaneComponent
    ]
})
export class SharedLibraryModule {
}
